const handleOnUnload = (event) => {
  event.preventDefault();
  const ev = event;
  ev.returnValue = '';
  return '';
};

export default handleOnUnload;
